  var toggle = document.getElementById("hamburger");
  toggle.setAttribute("aria-expanded", "false");

  var nav = responsiveNav("#sideNav", { // Selector
    animate: true, // Boolean: Use CSS3 transitions, true or false
        transition: 284, // Integer: Speed of the transition, in milliseconds
        label: "", // String: Label for the navigation toggle
        insert: "before", // String: Insert the toggle before or after the navigation
        customToggle: "hamburger", // Selector: Specify the ID of a custom toggle
        closeOnNavClick: false, // Boolean: Close the navigation when one of the links are clicked
        openPos: "relative", // String: Position of the opened nav, relative or static
        navClass: "nav-collapse", // String: Default CSS class. If changed, you need to edit the CSS too!
        navActiveClass: "jsNavActive", // String: Class that is added to html element when nav is active
        jsClass: "js", // String: 'JS enabled' class which is added to html element
        init: function(){}, // Function: Init callback
        open: function(){
          toggle.setAttribute("aria-expanded", "true");
        }, // Function: Open callback
        close: function(){
          toggle.setAttribute("aria-expanded", "false");
        } // Function: Close callback
      });

      // responsive-nav toggles on mouseup and on Enter keyup. A button also
      // fires click for Enter, which that library swallows. Space does not
      // toggle there, so handle Space here and keep it from scrolling.
      toggle.addEventListener("keydown", function (e) {
        if (e.key === " " || e.key === "Spacebar") {
          e.preventDefault();
          nav.toggle();
        }
      }, false);

      // Set the click handler for hamburgerMobile
      var jumpToMenu = document.getElementById("hamburgerMobile");
      jumpToMenu.addEventListener("click", function (e) {
        e.preventDefault();
        var element = document.getElementById("bottomNavContainer");
        element.scrollIntoView(true);
      }, false);

      // This div element starts out hidden via the HTML to prevent FOUC, once loaded unhide it (it is off screen)
      document.getElementById("sideNav").style.display = 'block';

      // Initialize the menu to be normally closed
      nav.close();
